import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type MediaSortOption = "newest" | "oldest" | "nameAsc" | "nameDesc";

export const DEFAULT_MEDIA_SORT_OPTION: MediaSortOption = "newest";

const OPTIONS: SortOption<MediaSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function mediaSortOptionLabel(option: MediaSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function mediaSortOptionToParams(option: MediaSortOption): {
  sortBy: "created_at" | "title";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "created_at", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "created_at", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "title", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "title", sortOrder: "DESC" };
  }
}

export default function SortMediaPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: MediaSortOption;
  setSortOption: (option: MediaSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Media"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
